import { render, staticRenderFns } from "./Recommends.vue?vue&type=template&id=5db79249&scoped=true&"
import script from "./Recommends.vue?vue&type=script&lang=js&"
export * from "./Recommends.vue?vue&type=script&lang=js&"
import style0 from "./Recommends.vue?vue&type=style&index=0&id=5db79249&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db79249",
  null
  
)

export default component.exports